import { Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CheckBox from '../../../components/Form/Checkbox'
import DateField from '../../../components/Form/Date'
import Select from '../../../components/Form/Select'
import SelectCNHType from '../../../components/Form/SelectCNHType'
import SelectOrigin from '../../../components/Form/SelectOrigin'
import SelectPoolPoint from '../../../components/Form/SelectPoolPoint'
import SelectSupplier from '../../../components/Form/SelectSupplier'
import SelectVehicleType from '../../../components/Form/SelectVehicleType'
import TextField from '../../../components/Form/TextField'
import { useAuth } from '../../../hooks/auth'
import { DriverInfo, MvmSearch } from '../../../interfaces/Mvm'
import MvmStatus from '../../../interfaces/MvmStatus'
import MvmApi from '../../../services/MvmApi'
import VehicleApi from '../../../services/VehicleApi'
import VehicleTypeApi from '../../../services/VehicleTypeApi'
import { POOL_POINT_LIST } from "../../../utils/constants"
import utilsDate from '../../../utils/Date'
import { useStyles } from '../Style'
type props = any;

const MvmSubmitSummary: React.FC<props> = ({ control, setValue, mvm, edit, getValues, isEditDraft }) => {
    const { user, hasPermission, isPortoReal } = useAuth()
    const classes = useStyles()
    const { t: tMvm } = useTranslation("Mvm")
    const [drivers, setDrivers] = useState<DriverInfo[]>([]);
    const [vehicle, setVehicle] = useState<any>(null);
    const [loadingVehicle, setLoadingVehicle] = useState<boolean>(false);

    useEffect(() => {
        if (!mvm) {
            return
        }

        var suppliers: { code: any; label: any; supplierCorporateName: any; uf: any; }[] = [];
        mvm.suppliers.forEach((element: { supplierId: { toString: () => any; }; supplierCorporateName: any; supplierUF: any; }) => {
            suppliers.push({ code: element.supplierId.toString(), label: element.supplierId.toString() + ' - ' + element.supplierCorporateName, supplierCorporateName: element.supplierCorporateName, uf: element.supplierUF })
        })

        setValue('suppliersView', suppliers.map(el => el.label).join(", "))
        setValue('shippingSupplierView', mvm.shippingSupplierId.toString() + ' - ' + mvm.shippingSupplierCorporateName)

        if (mvm.shippingCompanySupplierId)
            setValue('shippingCompanySupplierView', mvm.shippingCompanySupplierId.toString() + ' - ' + mvm.shippingCompanySupplierCorporateName)

        setValue('driverCNHTypeView', mvm.driverCNHType)
        setValue('vehicleTypeView', mvm.vehicleTypeDescription)

        setValue('suppliers', suppliers)
        setValue('shippingSupplier', { code: mvm.shippingSupplierId.toString(), label: mvm.shippingSupplierId.toString() + ' - ' + mvm.shippingSupplierCorporateName, cdlcCode: mvm.shippingSupplierCdlcCode, sapCode: mvm.shippingSupplierSapCode })

        if (mvm.shippingCompanySupplierId) {
            setValue('shippingCompanySupplier', { code: mvm.shippingCompanySupplierId.toString(), label: mvm.shippingCompanySupplierId.toString() + ' - ' + mvm.shippingCompanySupplierCorporateName, cnpj: mvm.shippingCompanySupplierCnpj, scacCode: mvm.shippingCompanySupplierScacCode, sapCode: mvm.shippingCompanySupplierSapCode })
        }

        setValue('driverName', { code: mvm.driverName, label: mvm.driverName })
        setValue('driverNameView', mvm.driverName)
        setValue('driverRGNumber', mvm.driverRGNumber)
        setValue('driverCPFNumber', mvm.driverCPFNumber)
        setValue('driverCNHType', { code: mvm.driverCNHType, label: mvm.driverCNHType })
        setValue('driverCNHNumber', mvm.driverCNHNumber)
        setValue('driverCNHExpirationDate', mvm.driverCNHExpirationDate)
        setValue('vehiclePlateNumber', mvm.vehiclePlateNumber)
        setValue('cartPlateNumber', mvm.cartPlateNumber)
        setValue('vehicleType', { code: mvm.vehicleType, label: mvm.vehicleTypeDescription })
        setValue('vehicleBrandDescription', mvm.vehicleBrandDescription)
        setValue('helperQuantity', mvm.helperQuantity)
        setValue('cTeNumber', mvm.cTeNumber)
        setValue('observation', mvm.observation)
        setValue('containerNumber', mvm.containerNumber)
        setValue('pcabNumber', mvm.pcabNumber)
        if (mvm.poolPoint !== "" && mvm.poolPoint !== null){
            setValue('poolPoint', {code: mvm.poolPoint, label: POOL_POINT_LIST.filter((el: any) => el.code === mvm.poolPoint)[0].label} )
            setValue('poolPointView', POOL_POINT_LIST.filter((el: any) => el.code === mvm.poolPoint)[0].label)
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mvm, user])

    const handleSearchDriver = async (driver: any) => {
        let items: any[] = [];
        var threeMonthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 3, 
            new Date().getDate()
        );

        if (driver.length >= 3){
        let params: MvmSearch = {
            driverName: driver,
            companyId: +user.company.companyID,
            pageSize: 10,
            pageIndex: 0,
            submitDateStart: utilsDate.ConvertDateToStringYYYYMMDD(threeMonthAgo)
        }

        await MvmApi.getDriverData(params)
            .then(result => {
                items = result ? result.map((driver: DriverInfo) => {
                    return {
                        code: driver.driverName,
                        label: driver.driverName,
                        driverName: driver.driverName || "",
                        driverRGNumber: driver.driverRGNumber || "",
                        driverCPFNumber: driver.driverCPFNumber || "",
                        driverCNHType: driver.driverCNHType || "",
                        driverCNHNumber: driver.driverCNHNumber || "",
                        driverCNHExpirationDate: driver.driverCNHExpirationDate || "",
                    };
                }) : [];
                setDrivers(items);
            });

        return items;
    }
    }

    const handleDriverChange = (driver: any) => {

        if (!driver) return

        setValue('driverName', { code: driver.driverName, label: driver.driverName })
        setValue('driverRGNumber', driver.driverRGNumber)
        setValue('driverCPFNumber', driver.driverCPFNumber)
        setValue('driverCNHType', { code: driver.driverCNHType, label: driver.driverCNHType })
        setValue('driverCNHNumber', driver.driverCNHNumber)
        setValue('driverCNHExpirationDate', driver.driverCNHExpirationDate)
    }

    const searchVehicle = async () => {
        setLoadingVehicle(true);
        const vehiclePlateNumber = getValues()?.vehiclePlateNumber;
        if (vehiclePlateNumber !== '') {
            const result: any[] = await VehicleApi.getVehicleByPlateNumber(vehiclePlateNumber)!;
            if (result?.length > 0) {
                setVehicle(result[0]);
                setValue('newVehicle', null);
            } else {
                setVehicle(null);
                setValue('newVehicle', { vehiclePlateNumber });
            }
        }
        setLoadingVehicle(false);
    }

    useEffect(() => {
        async function resolveVehicleType() {
            if (vehicle) {
                let vehicleTypeLabel = vehicle.vehicleTypeDescription;
                if (!vehicleTypeLabel && vehicle.vehicleType) {
                    try {
                        const vt = await VehicleTypeApi.getVehicleType(vehicle.vehicleType);
                        vehicleTypeLabel = vt?.description || '';
                    } catch {
                        vehicleTypeLabel = '';
                    }
                }
                setValue('vehicleType', { code: vehicle.vehicleType, label: vehicleTypeLabel || '' });
                setValue('cartPlateNumber', vehicle.cartPlateNumber);
                setValue('vehicleBrandDescription', vehicle.vehicleManufacturer);
            } else {
                setValue('vehicleType', {});
                setValue('cartPlateNumber', '');
                setValue('vehicleBrandDescription', '');
            }
        }
        resolveVehicleType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicle]);

    return (
        <Grid style={{ marginTop: 20, width: "98%", marginBottom: 10 }}>
            {edit === true ?
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <SelectSupplier
                            label={tMvm("suppliers")}
                            name={"suppliers"}
                            control={control}
                            style={{ width: '100%' }}
                            setValue={setValue}
                            loadUserSupplier={(mvm === null)}
                            multiple={true} />
                    </Grid>

                    <Grid item xs={4}>
                        <SelectSupplier
                            label={tMvm("shippingSupplier")}
                            name={"shippingSupplier"}
                            control={control}
                            setValue={setValue}
                            multiple={false}
                            loadUserSupplier={(mvm === null)}
                            style={{ width: '100%' }} />
                    </Grid>

                    <Grid item xs={4}>
                        <SelectSupplier
                            label={tMvm("shippingCompanySupplier")}
                            name={"shippingCompanySupplier"}
                            control={control}
                            style={{ width: '100%' }}
                            setValue={setValue}
                            multiple={false}
                            loadUserSupplier={(mvm === null)}
                            serviceType={'T'} />
                    </Grid>
                </Grid>
                :
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <TextField
                            label={tMvm("suppliers")}
                            name="suppliersView"
                            control={control}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }} />
                    </Grid>

                    <Grid item xs={4}>
                        <TextField
                            label={tMvm("shippingSupplier")}
                            name="shippingSupplierView"
                            control={control}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }} />
                    </Grid>

                    <Grid item xs={4}>
                        <TextField
                            label={tMvm("shippingCompanySupplier")}
                            name="shippingCompanySupplierView"
                            control={control}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }} />
                    </Grid>
                </Grid>
            }

            {/* se estiver visualizando e não tiver permissão esconder os campos */}
            {(!mvm?.id || mvm.status === MvmStatus.FLAG_STATUS_DRAFT || hasPermission('VIS_SEGURANCA_PATRIMONIAL')) && (
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        {(edit === true ?
                            <Select
                                freeSolo={true}
                                label={tMvm("driverName")}
                                name="driverName"
                                control={control}
                                options={drivers}
                                getOptionLabel={(option: any) => option.driverName}
                                searchFunction={handleSearchDriver}
                                onChange={handleDriverChange}
                                debounceMs={1000}
                                onInputChangeAditional={(value: any) => setValue('driverName', { code: value, label: value })}
                            />
                            :
                            <TextField
                                label={tMvm("driverName")}
                                name="driverNameView"
                                control={control}
                                fullWidth
                                onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 20) }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: edit === true ? false : true,
                                    classes: {
                                        input: edit === true ? classes.rootTextBox : classes.inputBlocked
                                    }
                                }} />
                        )}
                    </Grid>

                    <Grid item xs={2}>
                        <TextField
                            label={tMvm("driverRGNumber")}
                            name="driverRGNumber"
                            control={control}
                            type="number"
                            fullWidth
                            onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 20) }}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: edit === true ? false : true,
                                classes: {
                                    input: edit === true ? classes.rootTextBox : classes.inputBlocked
                                }
                            }} />
                    </Grid>

                    <Grid item xs={2}>
                        <TextField
                            label={tMvm("driverCPFNumber")}
                            name="driverCPFNumber"
                            control={control}
                            type="number"
                            fullWidth
                            onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 11) }}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: edit === true ? false : true,
                                classes: {
                                    input: edit === true ? classes.rootTextBox : classes.inputBlocked
                                }
                            }} />
                    </Grid>
                    <Grid item xs={2}>
                        {edit === true ?
                            <SelectCNHType
                                label={tMvm('driverCNHType')}
                                name={'driverCNHType'}
                                control={control} />
                            :
                            <TextField
                                label={tMvm("driverCNHType")}
                                name="driverCNHTypeView"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        }
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            label={tMvm("driverCNHNumber")}
                            name="driverCNHNumber"
                            control={control}
                            type="number"
                            fullWidth
                            onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 11) }}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: edit === true ? false : true,
                                classes: {
                                    input: edit === true ? classes.rootTextBox : classes.inputBlocked
                                }
                            }} />
                    </Grid>

                    <Grid item xs={2}>
                        <DateField label={tMvm("driverCNHExpirationDate")} name="driverCNHExpirationDate" control={control} fullWidth
                            allowPast={false}
                            InputLabelProps={{ shrink: true }}
                            disable={edit === true ? false : true}
                            InputProps={{
                                readOnly: edit === true ? false : true,
                                classes: {
                                    input: edit === true ? classes.rootTextBox : classes.inputBlocked
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            )}
            <Grid container spacing={1}>
                <Grid item xs={2}>
                    <TextField
                        label={tMvm("vehiclePlateNumber")}
                        name="vehiclePlateNumber"
                        disable={vehicle !== null || loadingVehicle}
                        control={control}
                        mask="aaa9*99"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: edit === true ? false : true,
                            classes: {
                                input: edit === true ? classes.rootTextBox : classes.inputBlocked
                            }
                        }}
                        onBlur={(e: any) => searchVehicle()}
                    />
                </Grid>

                <Grid item xs={2}>
                    <TextField
                        label={tMvm("cartPlateNumber")}
                        name="cartPlateNumber"
                        control={control}
                        mask="aaa9*99"
                        fullWidth
                        disable={vehicle !== null || loadingVehicle}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: edit === true ? false : true,
                            classes: {
                                input: edit === true ? classes.rootTextBox : classes.inputBlocked
                            }
                        }} />
                </Grid>

                <Grid item xs={2}>
                    {edit === true ?
                        <SelectVehicleType
                            label={tMvm('vehicleType')}
                            name={'vehicleType'}
                            disabled={vehicle !== null || loadingVehicle}
                            control={control}
                        />
                        :
                        <TextField
                            label={tMvm("vehicleType") + '*'}
                            name="vehicleTypeView"
                            control={control}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }} />
                    }
                </Grid>

                <Grid item xs={2}>
                    <TextField
                        label={tMvm("vehicleBrandDescription")}
                        name="vehicleBrandDescription"
                        disable={vehicle !== null || loadingVehicle}
                        control={control}
                        fullWidth
                        onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 30) }}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: edit === true ? false : true,
                            classes: {
                                input: edit === true ? classes.rootTextBox : classes.inputBlocked
                            }
                        }} />
                </Grid>

                <Grid item xs={2}>
                    <TextField
                        label={tMvm("helperQuantity")}
                        name="helperQuantity"
                        control={control}
                        type="number"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: edit === true ? false : true,
                            classes: {
                                input: edit === true ? classes.rootTextBox : classes.inputBlocked
                            }
                        }} />
                </Grid>

                <Grid item xs={2}>
                    <TextField
                        label={tMvm("cTeNumber")}
                        name="cTeNumber"
                        control={control}
                        type="number"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: edit === true ? false : true,
                            classes: {
                                input: edit === true ? classes.rootTextBox : classes.inputBlocked
                            }
                        }} />
                </Grid>
                
                <Grid item xs={2}>
                        {edit === true ?
                            <SelectPoolPoint
                            label={tMvm('poolpoint')}
                            name={'poolPoint'}
                            control={control} />
                            :
                            <TextField
                                label={tMvm("poolpoint")}
                                name="poolPointView"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        }
                </Grid>
            </Grid>

            {isPortoReal() &&
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <TextField
                            label={tMvm("containerNumber")}
                            name="containerNumber"
                            control={control}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: edit === true ? false : true,
                                classes: {
                                    input: edit === true ? classes.rootTextBox : classes.inputBlocked
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={2}>
                        <TextField
                            label={tMvm("pcabNumber")}
                            name="pcabNumber"
                            control={control}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: edit === true ? false : true,
                                classes: {
                                    input: edit === true ? classes.rootTextBox : classes.inputBlocked
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={2}>
                        <SelectOrigin
                            label={tMvm('origin')}
                            name={'origin'}
                            edit={edit}
                            value={mvm?.origin}
                            setValue={setValue}
                            classes={classes}
                            control={control}
                        />

                    </Grid>
  
                </Grid>
            }

            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <TextField
                        label={tMvm("observation")}
                        name="observation"
                        control={control}
                        variant={'outlined'}
                        multiline={true}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: edit === true ? false : true,
                            classes: {
                                input: edit === true ? classes.rootTextBox : classes.inputBlocked
                            }
                        }} />
                </Grid>
            </Grid>

            {
                +user.company.plantID === 4 &&
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <CheckBox name='composition'
                            label={tMvm("MvmComposition")}
                            control={control}
                            disable={mvm && isEditDraft !== true}
                            style={{ paddingBottom: '0px', paddingTop: '0px', paddingLeft: '20px' }}
                        />
                    </Grid>
                </Grid>
            }

        </Grid>
    )
}

export default MvmSubmitSummary

